import React from 'react'
import { motion } from 'framer-motion'
import useEntryMotion from './useEntryMotion'

/**
 * Section heading whose words rise into view one after another, each from
 * behind its own mask. Used for the big titles down the homepage so they
 * arrive with the same weight as the hero line.
 *
 * The full text stays in one element for screen readers and crawlers — the
 * words are only wrapped for the animation.
 */
const SplitHeading = ({ text, as: Tag = 'h2', className, delay = 0, stagger = 0.05 }) => {
  const animateIn = useEntryMotion('scroll')
  const Motion = motion[Tag] || motion.h2
  const words = String(text || '').split(' ')

  if (!animateIn) {
    return <Tag className={className}>{text}</Tag>
  }

  return (
    <Motion
      className={className}
      initial='hidden'
      whileInView='visible'
      viewport={{ once: true, amount: 0.4 }}
      variants={{
        hidden: {},
        visible: { transition: { staggerChildren: stagger, delayChildren: delay } },
      }}
      aria-label={text}
    >
      {words.map((word, i) => (
        <span key={`${word}-${i}`} className='split-word-mask' aria-hidden='true'>
          <motion.span
            className='split-word'
            variants={{
              hidden: { y: '110%' },
              visible: { y: '0%', transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1] } },
            }}
          >
            {word}
            {i < words.length - 1 ? ' ' : ''}
          </motion.span>
        </span>
      ))}
    </Motion>
  )
}

export default SplitHeading
